import React from "react";
import OurDate from "shared/components/OurDate";
import {
  productIsDeleted,
  productApprovalRequested,
  publishingIsInProcess,
  productIsInProcess,
} from "shared/model-helpers/productHelper";
import Timer from "./timer.svg";

export default function ProductStateInformation({ product }) {
  const publishOn = productApprovalRequested(product)
    ? null
    : product.publishOn;

  if (productIsDeleted(product)) {
    return (
      <h5>
        <span
          className="glyphicon glyphicon glyphicon-info-sign product-information"
          aria-hidden="true"
        />
        Dieses Produkt wurde schon gelöscht
      </h5>
    );
  }

  if (publishingIsInProcess(product)) {
    return (
      <div>
        <h5>
          <img src={Timer} className="timer" alt="remaining time" />
          Veröffentlichung in Planung
        </h5>
      </div>
    );
  }

  if (productIsInProcess(product)) {
    return (
      <h5>
        <span
          className="glyphicon glyphicon-pencil product-information"
          aria-hidden="true"
        />
        Produkt in Bearbeitung
      </h5>
    );
  }

  return (
    <div>
      <img src={Timer} className="timer" alt="remaining time" />
      <OurDate value={publishOn} />
    </div>
  );
}
